import api from '../api'

export default {
  namespaced: true,
  state: {
    bigScreenInfo: {}, // 大屏的数据
    staffListInfo: {} // 星级服务人员信息
  },
  mutations: {
    SET_SCREEN_DATA (state , data) {
      state.bigScreenInfo = data
    },
    SET_STAFF_LIST (state , data) {
      state.staffListInfo = data
    }
  },
  actions: {
    GET_STAFF_LIST ({ commit, dispatch }, { pageNum, pageSize, title } = {}) {
      return new Promise((resolve, reject) => {
        let data = { pageNum: 1, pageSize: 10 }
        // 判断是否需要添加参数
        if (pageNum) data.pageNum = pageNum
        if (pageSize) data.pageSize = pageSize
        if (title) data.title = title

        api.getStaffList({ data }).then((res) => {
          commit('SET_STAFF_LIST', res.payload)
          resolve(res)
        }).catch((rej) => {
          window.myVue.$message.error(rej.message)
        })
      })
    },
    GET_SCREEN_DATA ({ commit, dispatch }, flag) {
      let params = { moduleFlag: flag }
      return api.getScreenData({ params }).then((res) => {
        commit('SET_SCREEN_DATA', res.payload)
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    },
    SAVE_SCREEN_DATA ({ commit, dispatch }, { flag, dataString, dataObject}) {
      let data = { moduleFlag: flag, dataString, dataObject}
      return api.saveScreenData({ data }).then((res) => {
        window.myVue.$message.success('保存成功')
        return res
      }).catch((rej) => {
        window.myVue.$message.error(rej.message)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/screenManage/store/index.js